// src/components/Header.js
import React from 'react';

const Header = () => {
  return (
    <div id="header">
      <div className="container">
        <nav>
          {/* Updated logo for SafeGam AI */}
          <img src="images/safegam.gif" className="logo" alt="SafeGam AI Logo" />
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#utilities">Utilities</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
        <div className="header-text">
          <p>AI-Driven Security for Gambling & Blockchain</p>
          <h1 className="glitch-text" data-text="Welcome to SafeGam AI">
            Welcome to <span>SafeGam AI</span>
            <br />
            Play & Invest Smarter
          </h1>
          <br />
          <div className="header-buttons">
            <a
              href="https://x.com/safegam"
              target="_blank"
              rel="noreferrer"
              className="chrome-extension-link"
            >
              <button className="primary-button">Follow Twitter (X)</button>
            </a>
            <p>-</p>
            <a
              href="https://t.me/safegam"
              target="_blank"
              className="dapp-link"
            >
              <button className="secondary-button">Join Telegram</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
